import { graphql, Link, useStaticQuery } from 'gatsby'
import { MdxFrontmatter, MdxFrontmatterLinks, SiteSectionQuery } from 'generated/types/gatsby'
import './search.scss'
import React from 'react'
import { SearchResult } from './Search'

interface SearchResultProps {
  readonly page: SearchResult
  readonly showProductTag: boolean
  readonly query: string
}

interface ProductName {
  node: { __typename?: 'Mdx' } & {
    frontmatter: { __typename?: 'MdxFrontmatter' } & Pick<MdxFrontmatter, 'title'> & {
        links: Array<
          { __typename?: 'MdxFrontmatterLinks' } & Pick<
            MdxFrontmatterLinks,
            'path' | 'header' | 'title'
          >
        >
      }
  }
}

const getProductName = (splitUrl: string[], siteSections: SiteSectionQuery) => {
  return siteSections.allMdx.edges.find((section) => {
    return section.node.frontmatter.title === splitUrl[0]
  })
}

const getDocumentName = (url: string, productName?: ProductName) => {
  const node = productName?.node.frontmatter.links.find((link) => link.path.startsWith(url))
  return node?.header || node?.title
}

export const SearchResultItem = ({ page, showProductTag, query }: SearchResultProps) => {
  const siteSections = useStaticQuery<SiteSectionQuery>(graphql`
    query SiteSection {
      allMdx(filter: { fields: { sourceName: { eq: "cards" } } }) {
        edges {
          node {
            frontmatter {
              title
              links {
                header
                path
                title
              }
            }
          }
        }
      }
    }
  `)

  // split found page url to productName (0), documentName (1) /LiveNX/LiveNX8.3_UG/
  const splitUrl = page.url.replace(/^\//, '').split('/')
  // get productName i.e., tag LiveNX, Omnipeek etc.
  const productName = getProductName(splitUrl, siteSections)
  // get documentName i.e., What's New, User Guide etc.
  const documentName = getDocumentName(splitUrl[1], productName)

  return (
    <Link to={page.url} key={page.url} state={{ query: query }}>
      <p className={'la-search-result-list__item-breadcrumbs'}>
        {!showProductTag && (
          <strong className={'la-search-result-list__item-breadcrumbs-home'}>
            {productName?.node.frontmatter.title}
          </strong>
        )}

        {documentName && (
          <span className={'la-search-result-list__item-breadcrumbs-children'}>{documentName}</span>
        )}

        {page.chapter && (
          <span className={'la-search-result-list__item-breadcrumbs-children'}>{page.chapter}</span>
        )}

        {page.section && (
          <span className={'la-search-result-list__item-breadcrumbs-children'}>{page.section}</span>
        )}

        {page.title && (
          <span className={'la-search-result-list__item-breadcrumbs-children'}>{page.title}</span>
        )}
      </p>

      <div
        className="la-search-result-list__item-details"
        dangerouslySetInnerHTML={{ __html: page.excerpt }}
      />
    </Link>
  )
}
